var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M6.9782,18.2074 l5.1587,3.6376c0.2321,0.1762,0.1917,0.5036,0,0.6958l-0.582,0.5816c-0.1917,0.1922-0.4417,0.1441-0.6951,0l-5.2111-3.5854"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 4.6549,15.8839 4.6534,15.883 3.2827,17.2638 1.2641,18.6251 4.2404,21.6011 5.6487,19.5369 6.9789,18.2077 6.9782,18.2074 19.1376,11.8615 11.0003,3.7242 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M21.4979,8.4497 c0.1276-3.8822-3.0291-7.0326-6.9052-6.9053"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M15.3505,4.5893 c1.7659-0.1162,3.2187,1.3378,3.1026,3.1026"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 4.6548,
    y1: 15.8839,
    x2: 6.9781,
    y2: 18.2074
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 3.2827,
    y1: 17.2638,
    x2: 5.6487,
    y2: 19.5369
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0136,
    y: 0.0002,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSources);
export default __webpack_public_path__ + "static/media/sources.2abc34849ed0b3ae28102fbcb5ef3704.svg";
export { ForwardRef as ReactComponent };